
    import Vue from "vue";
    import {Ripple} from 'vuetify/lib/directives';

    // @ts-ignore
export default Vue.extend({
  name: "RomaPurposeModalForm",
  async created() {
    await this.getCategoriesAndSubjects();
  },
  props: {
    color: {
      type: String,
      required: true
    },
    currentList: {
      type: Array,
      required: true
    },
    addSkills: {
      type: Boolean | null,
      required: true
    },
    value: Boolean,
    unit: {
      type: Object,
      required: true
    },
    maxWidth: {
      type: String,
      default: "50%"
    },
    overlayOpacity: {
      type: String,
      default: "0.8"
    },
    persistent: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dispatch: '',
      addModalTittle: '',
      valid: false,
      loading: null,
      showing: this.value,
      subject: null,
      schoolLevel: null,
      course: null,
      availableSubjects: [],
      availableLevels: [],
      list: [],
      headerElements: [
        {
          text: "Nombre",
          value: "nombre",
          align: 'start',
        },
      ],
      selectedRows: [],
    };
  },
  methods: {
    getSelectedSchoolYear(){
      return JSON.parse(localStorage.getItem('roma')) && JSON.parse(localStorage.getItem('roma')).organizer &&
          JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool ?
          JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool.yearSelected : null;
    },
    setDefaultValues() {
      this.selectedRows = [];
      this.list = [];
    },
    addElements() {
      this.$emit(this.addSkills ? "skillsAdded" : "attitudesAdded", this.selectedRows);
      this.show(false);
      this.selectedRows = [];
    },
    show(value) {
      this.$emit("input", value);
    },
    async getCategoriesAndSubjects() {
      const year = this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : new Date().getFullYear();
      const response = await this.$store.dispatch("getSectionWithSubjects", year);
      const secciones = response.data.content.secciones;
      let educationList = secciones.map((section: any) => {
          return section.categoria.educacion.nombre;
      });
      //remove duplicates from educationList
      educationList = educationList.filter((item, index) => educationList.indexOf(item) === index);
      let educationListWithCategories = educationList.map((education: any) => {
          let educationSections = secciones.filter((section: any) => section.categoria.educacion.nombre === education);
          let categories = educationSections.map((section: any) => {
              return {
                  id: section.categoria.id,
                  name: section.categoria.nombre,
                  subjects: section.subjects.map((subject: any) => {
                      return {
                          id: subject.id,
                          name: subject.name,
                          cod: subject.cod
                      }
                  })
              }
          });

          let categoriesUnique = _.uniqBy(categories, 'id');
          categoriesUnique = categoriesUnique.map((category: any) => {
              let subjectsUnique: any = [];
              categories.forEach((category2: any) => {
                  if (category.id === category2.id) {
                      subjectsUnique = subjectsUnique.concat(category2.subjects);
                  }
              });
              subjectsUnique = _.uniqBy(subjectsUnique, 'id');
              category.subjects = subjectsUnique;
              return category;
          });

          return {
              name: education,
              categories: categories
          }
      });
      const levels: any[] = [];
      this.educations = educationListWithCategories;

      educationListWithCategories.forEach((education: any)=>{
          levels.push({
              header: education.name,
          });
          education.categories.forEach((category: any)=>{
              levels.push(category);
          });
      })

      this.availableLevels = levels;

      this.schoolLevel = this.availableLevels.find(
          (education: any) => education.id === this.unit.id_nivel
      );

      this.subject = this.schoolLevel.subjects.find(
          (subject: any) => subject.id === this.unit.id_asignatura
      );
    },
    getListBySubjectAndCategory() {
      if (this.schoolLevel && this.subject && this.dispatch) {
        this.loading = this.color;
        let request = new URLSearchParams(
          `idCategoria=${this.schoolLevel.id}&idAsignatura=${this.subject.id}&idPlanUnidad=${this.unit.id}`
        );
        this.$store.dispatch(this.dispatch, {params: request}).then(response => {
          this.loading = null;
          this.list = response.data.content;
        });
      }
    },
    changeCategoryEvent(){
      if(this.schoolLevel){
        if(this.schoolLevel.subjects.find((subject: any) => subject.id === this.subject.id) == null){
            this.subject = this.schoolLevel.subjects[0];
        }
      }
    },
  },
  computed: {
    dataToGetElements() {
      return this.schoolLevel && this.subject;
    },
    filteredList() {
      const currentListIds = this.currentList.map((element: any) => element.id);
      return this.list.filter((element: any) => !currentListIds.includes(element.id));
    },
  },
  watch: {
    dataToGetElements() {
      this.setDefaultValues();
      this.getListBySubjectAndCategory();
    },
    addSkills(newValue) {
      this.addModalTittle = newValue
        ? this.$vuetify.lang.t('$vuetify.component.romaPurpose.addSkill')
        : this.$vuetify.lang.t('$vuetify.component.romaPurpose.addActitude');
      this.dispatch = newValue ? 'getSkills' : 'getAttitudes';
      this.setDefaultValues();
      this.getListBySubjectAndCategory();
    },
  },
  directives: {
    Ripple
  }
});
